export const minPasswordLength = 8;

export const minUsernameLength = 4;
